import { fetchJson } from 'src/utils/fetch';

const getSkusDiseases = (data) => {
  return fetchJson({
    url: `/api/v1/goods/disease/skus/${data.skus}`,
    type: 'GET',
  });
};
const getPatientList = (data) => {
  return fetchJson({
    url: '/api/v1/patient/info/queryListByAccountId',
    type: 'GET',
    needLoading: true,
  });
};
// 添加用药人
const addPatient = (data) => {
  return fetchJson({
    url: '/api/v1/patient/info/addRecord',
    type: 'POST',
    data,
    needLoading: true,
  });
};
// 删除用药人
const deleteById = (data) => {
  return fetchJson({
    url: '/api/v1/patient/info/deleteById',
    type: 'GET',
    data,
    needLoading: true,
  });
};
const uploadMultipleFiles = (data) => {
  return fetchJson({
    url: '/api/v1/oss/uploadMultipleFiles',
    type: 'UPLOAD',
    data,
  });
};
const uploadFile = (data) => {
  return fetchJson({
    url: '/api/v1/operator/inquiryDrug/upload',
    type: 'UPLOAD',
    data,
  });
};
const uploadFileWithoutToken = (data) => {
  return fetchJson({
    url: '/api/v1/operator/inquiryDrug/uploadWithoutToken',
    type: 'UPLOAD',
    data,
  });
};
const submitData = (data) => {
  return fetchJson({
    url: '/api/operator/inquiryDrug/submitData',
    type: 'POST',
    data,
    needLoading: true,
  });
};
const getOrderRelationDetail = (data) => {
  return fetchJson({
    url: '/api/v1/bops/order/relation/detail',
    type: 'GET',
    data,
    needLoading: true,
  });
};
// 查询用药人详情
const queryPatientDetail = (data) => {
  return fetchJson({
    url: '/api/v1/patient/info/queryById',
    type: 'GET',
    data,
    needLoading: true,
  });
};
// 查询处方详情
const getPrescription = (data) => {
  return fetchJson({
    url: `/api/v1/operator/inquiryDrug/getPrescription?prescriptionId=${data.prescriptionId}`,
    type: 'POST',
    needLoading: true,
  });
};
// 查询处方详情，订单用
const getPrescriptionInfo = (data) => {
  return fetchJson({
    url: `/api/v1/bops/order/hp/token?orderId=${data.orderId}`,
    type: 'GET',
    needLoading: true,
  });
};

export { getSkusDiseases, getPatientList, addPatient, uploadMultipleFiles, uploadFile, submitData, deleteById, getOrderRelationDetail, queryPatientDetail, getPrescription, getPrescriptionInfo, uploadFileWithoutToken };
